"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: background 0.1s linear, color 0.1s linear;\n  cursor: pointer;\n  border-radius: ", ";\n  padding: ", ";\n  color: ", ";\n  &:hover,\n  ", " {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockRadio = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_1 = require("../styled");

var Block_1 = require("../styled/Block");

function BlockRadio(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      value = _ref.value;
  return react_1.default.createElement(Label, {
    isSelected: selected
  }, react_1.default.createElement(Block_1.HSpaced, {
    align: 'flex-start'
  }, react_1.default.createElement(antd_1.Radio, {
    value: value
  }), react_1.default.createElement("div", null, children)));
}

exports.BlockRadio = BlockRadio;
var Label = styled_1.styled.label(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@padding-sm'];
}, function (props) {
  return props.theme['@gray-5'];
}, function (props) {
  return props.isSelected ? '&' : '.noop';
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@primary-color'];
});